import { useEffect, useState } from "react"
import { EmptyString, FormTypeView } from "utils/Constant"
import moment from "moment";
import { useNavigate } from "react-router-dom";
import { money } from "utils/helpers";
import BedIcon from "assets/icon/BedIcon";
import MoneyIcon from "assets/icon/MoneyIcon";
import { MainBodyCard } from "components/Cards/MainBodyCard";
import { useModal } from "utils/context/ModalContext";
import { PagesTitle } from "components/Cards/PagesTitle";
import { DashboardService } from "services/DashboardService";
import { BookingService } from "services/BookingService";

export default function Dashboard(){
    let navigate = useNavigate()

    const { fetchDashboardInfo } = DashboardService()
    const { fetchCheckInBooking, fetchCompleteBooking } = BookingService()

    const { showFail, showLoading, hideLoading, showSuccess, confirm } = useModal()

    const [incomeThisMonth, setIncomeThisMonth] = useState(EmptyString)
    const [expenseThisMonth, setExpenseThisMonth] = useState(EmptyString)
    const [roomOccupied, setRoomOccupied] = useState("0")
    const [checkInToday, setCheckInToday] = useState([])
    const [checkOutToday, setCheckOutToday] = useState([])
    const [unpaidTenant, setUnpaidTenant] = useState([])
    const [depositOnHold, setDepositOnHold] = useState(EmptyString)
    const [depositOwned, setDepositOwned] = useState(EmptyString)
    const [allTimeIncome, setAllTimeIncome] = useState(EmptyString)
    const [allTimeExpense, setAllTimeExpense] = useState(EmptyString)
    const [nettIncome, setNettIncome] = useState(EmptyString)

    const bookingClick = (bookingId) => {
        navigate("/booking/form?bookingId=" + bookingId + "&formType=" + FormTypeView)
    }
    const expenseClick = () => {
        navigate('/expense')
    }
    const roomClick = () => {
        navigate('/rooms')
    }
    const incomeClick = () => {
        navigate('/payment')
    }
    const depositClick = () => {
        navigate('/deposit')
    }

    const checkInBtnClick = async (id) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await checkInBooking(id)
            await getDashboardInfo()
        } finally {
            hideLoading()
        }
    }   
    const checkOutBtnClick = async (id) => {
        const onConfirm = await confirm()
        if (!onConfirm) return

        try {
            showLoading()

            await completeBooking(id)
            await getDashboardInfo()
        } finally {
            hideLoading()
        }
    }

    const getDashboardInfo = async () => {
        const res = await fetchDashboardInfo(
            moment(new Date()).format("M"), 
            moment(new Date()).format("yyyy"),
            moment(new Date()).format("M"),
            moment(new Date()).format("yyyy")
        )

        if (!res) return

        const data = res.data

        setRoomOccupied(data.dashboardInfo.occupiedRoom)
        setIncomeThisMonth(data.dashboardInfo.incomeThisMonth)
        setExpenseThisMonth(data.dashboardInfo.expenseThisMonth)

        setCheckInToday(data.checkInToday)
        setCheckOutToday(data.checkOutToday)
        setUnpaidTenant(data.unpaidTenant)
        setDepositOnHold(data.depositOnHold)
        setDepositOwned(data.depositOwned)
        setAllTimeIncome(data.allTimeIncome)
        setAllTimeExpense(data.allTimeExpense)
        setNettIncome(data.nettIncome)
    }
    const checkInBooking = async (id) => {
        await fetchCheckInBooking(id)
    }
    const completeBooking = async (bookingId) => {
        await fetchCompleteBooking(bookingId)
    }

    useEffect(() => {
        const onLoad = async () => {
            try {
                showLoading()

                await getDashboardInfo()
            }
            finally {
                hideLoading()
            }
        }

        onLoad()
    }, [])

    return(
        <MainBodyCard>
            <PagesTitle title='Dashboard' />
            
            <div className="flex flex-col sm:flex-row gap-4 mt-2">
                <div className="flex flex-col border rounded-md shadow-md h-24 px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    onClick={roomClick}
                >
                    <span className="tracking-wider">Room Occupied</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl tracking-wide">{roomOccupied}</span>
                            <span className="tracking-wider"> / 31</span>
                        </div>
                        <BedIcon className="w-8" />
                    </div>
                </div>
                
                <div className="flex flex-col border rounded-md shadow-md h-24 px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    onClick={incomeClick}
                >
                    <span className="tracking-wider">Rent Income</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl ">Rp {incomeThisMonth === EmptyString ? "-,-" : money(incomeThisMonth)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                    <div>
                        <span className="text-sm">{moment(new Date()).format("MMMM yyyy")}</span>
                    </div>
                </div>

                <div className="flex flex-col border rounded-md shadow-md h-24 px-4 py-2 w-full sm:w-3/12 bg-white cursor-pointer hover:bg-slate-100 transition-all"
                    onClick={expenseClick}
                >
                    <span className="tracking-wider cursor-pointer">Expense</span>
                    <div className="flex justify-between items-center cursor-pointer">
                        <div className="cursor-pointer">
                            <span className="text-2xl cursor-pointer">Rp {expenseThisMonth === EmptyString ? "-,-" : money(expenseThisMonth)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                    <div className="cursor-pointer">
                        <span className="text-sm cursor-pointer">{moment(new Date()).format("MMMM yyyy")}</span>
                    </div>
                </div>

                <div className="flex flex-col border rounded-md shadow-md h-24
                                px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    onClick={depositClick}
                >
                    <span className="tracking-wider">Deposit On Hold</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl tracking-wide">Rp {money(depositOnHold)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-2">
                <div className="flex flex-col border rounded-md shadow-md h-24
                                px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    onClick={depositClick}
                >
                    <span className="tracking-wider">Deposit Owned</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl tracking-wide">Rp {money(depositOwned)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                </div>

                <div className="hidden sm:flex flex-col border rounded-md shadow-md px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    // onClick={roomClick}
                >
                    <span className="tracking-wider">All Time Income</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl tracking-wide">Rp {money(allTimeIncome)}</span>
                        </div>
                        <MoneyIcon className="w-8 hidden sm:block" />
                    </div>
                </div>
                
                <div className="hidden sm:flex flex-col border rounded-md shadow-md px-4 py-2 w-full sm:w-3/12 bg-white hover:cursor-pointer hover:bg-slate-100 transition-all"
                    // onClick={incomeClick}
                >
                    <span className="tracking-wider">All Time Expense</span>
                    <div className="flex justify-between items-center">
                        <div>
                            <span className="text-2xl ">Rp {money(allTimeExpense)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                    <div>
                        {/* <span className="text-sm">{moment(new Date()).format("MMMM yyyy")}</span> */}
                    </div>
                </div>

                <div className="hidden sm:flex flex-col border rounded-md shadow-md px-4 py-2 w-full sm:w-3/12 bg-white cursor-pointer hover:bg-slate-100 transition-all"
                    // onClick={expenseClick}
                >
                    <span className="tracking-wider cursor-pointer">Nett Income</span>
                    <div className="flex justify-between items-center cursor-pointer">
                        <div className="cursor-pointer">
                            <span className="text-2xl cursor-pointer">Rp {money(nettIncome)}</span>
                        </div>
                        <MoneyIcon className="w-8" />
                    </div>
                    <div className="cursor-pointer">
                        {/* <span className="text-sm cursor-pointer">{moment(new Date()).format("MMMM yyyy")}</span> */}
                    </div>
                </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 mt-4">
                <div className="border rounded-md shadow-md bg-white w-full px-4 py-4">
                    <span className="font-semibold">Check In</span>
                    <hr className="mt-2" />
                    <div className="flex flex-col gap-4 mt-4 max-h-[400px] overflow-auto">
                        {checkInToday?.map((data, i) => {
                            return(
                                <div key={i} className="flex flex-col sm:flex-row gap-2 border sm:border-none sm:bg-none rounded-md sm:rounded-none p-2 sm:p-0">
                                    <div className={`flex flex-col border w-full rounded-md px-4 py-2 cursor-pointer hover:shadow-md hover:bg-slate-100 transition-all 
                                        ${moment(data.checkInDate).format('DD MMM yyyy') === moment(new Date()).format('DD MMM yyy') ? 'bg-lime-400' : ''} `}
                                        onClick={() => { bookingClick(data.bookingId) }}
                                    >
                                        <div className="flex justify-between cursor-pointer">
                                            <label className="cursor-pointer text-sm whitespace-nowrap text-ellipsis overflow-hidden w-7/12 sm:w-auto">{ data.tenantName }</label>
                                            <label className="cursor-pointer text-sm">{ moment(data.checkInDate).format('DD MMM yyyy') }</label>
                                        </div>
                                        
                                        <label className="cursor-pointer text-sm">{ data.roomNumber }</label>
                                    </div>

                                    <div className="w-full sm:w-auto">
                                        <button className="bg-black rounded-md px-4 py-2 flex justify-center items-center h-full w-full sm:w-auto"
                                            onClick={() => { checkInBtnClick(data.bookingId) }}
                                        >
                                            <span className="text-white text-sm sm:text-base">Check In</span>
                                        </button>
                                    </div>
                                    
                                </div>
                            )
                        })}
                        {checkInToday.length === 0 && (
                            <div className="flex justify-center">
                                <span>No data</span>
                            </div>
                        )}
                    </div>
                </div>

                <div className="border rounded-md shadow-md bg-white w-full px-4 py-4">
                    <span className="font-semibold">Check Out</span>
                    <hr className="mt-2" />
                    <div className="flex flex-col gap-4 mt-4 max-h-[400px] overflow-auto">
                        {checkOutToday?.map((data, i) => {
                            return(
                                <div key={i} className="flex flex-col sm:flex-row gap-2 border sm:border-none sm:bg-none rounded-md sm:rounded-none p-2 sm:p-0">
                                    <div className={`w-full flex flex-col border rounded-md px-4 py-2 cursor-pointer hover:shadow-md hover:bg-slate-100 transition-all
                                        ${moment(data.checkOutDate).format('DD MMM yyyy') === moment(new Date()).format('DD MMM yyy') ? 'bg-lime-400' : ''} `}
                                        onClick={() => { bookingClick(data.bookingId) }}
                                    >
                                        <div className="flex justify-between cursor-pointer">
                                            <label className="cursor-pointer text-sm whitespace-nowrap text-ellipsis overflow-hidden w-7/12 sm:w-auto">{ data.tenantName }</label>
                                            <label className="cursor-pointer text-sm">{ moment(data.checkOutDate).format('DD MMM yyyy') }</label>
                                        </div>
                                        
                                        <label className="cursor-pointer text-sm">{ data.roomNumber }</label>
                                    </div>

                                    <div>
                                        <button className="bg-black rounded-md px-4 py-2 flex justify-center items-center h-full w-full sm:w-auto"
                                            onClick={() => { checkOutBtnClick(data.bookingId) }}
                                        >
                                            <span className="text-white text-sm">Check Out</span>
                                        </button>
                                    </div>
                                </div>
                            )
                        })}

                        {checkOutToday.length === 0 && (
                            <div className="flex justify-center">
                                <span>No data</span>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            <div className="border rounded-md bg-white shadow-md p-4 mt-4">
                <div>
                    <span className="font-semibold">Unpaid Tenant</span>
                    <hr className="mt-2" />
                </div>

                <div className="flex flex-col gap-4 mt-4 max-h-[400px] overflow-auto">
                    {unpaidTenant?.map((data, i) => {
                        return(
                            <div key={i} className="flex flex-col border rounded-md px-4 py-2 cursor-pointer hover:shadow-md hover:bg-slate-100 transition-all"
                                onClick={() => { bookingClick(data.bookingId) }}
                            >
                                <div className="flex justify-between cursor-pointer">
                                    <label className="cursor-pointer text-sm whitespace-nowrap text-ellipsis overflow-hidden w-6/12 sm:w-auto">{ data.tenantName }</label>
                                    <label className="cursor-pointer">In : { moment(data.checkInDate).format('DD MMM yyyy') }</label>
                                </div>
                                
                                <label className="cursor-pointer">{ data.roomNumber }</label>
                            </div>
                        )
                    })}

                    {unpaidTenant.length === 0 && (
                        <div className="flex justify-center">
                            <span>No data</span>
                        </div>
                    )}
                </div>  
            </div>
        </MainBodyCard>
    )
}